import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

const NotFoundPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.number}>404</h1>
        <h1 className={styles.title}>Oops, page not found.</h1>
        <p className={styles.subtitle}>Sorry, the page you are looking for doesn't exist.</p>
        <p className={styles.message}>If you think something is broken, report a problem.</p>
        <div className={styles.actions}>
          <Link to="/" className={styles.button}>Return Home</Link>
          <Link to="/" className={`${styles.button} ${styles.reportButton}`}>Report Problem</Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
